export default __webpack_public_path__ + "static/media/backgroundmobile.a92a393c.png";